import React from 'react';
import Like from '../../../assets/images/SurveyThumbUp.svg';
import { getPathForSurvey } from '../../../utils/helper';
import { useNavigate } from 'react-router-dom';
import { pulseSurveyPageData } from '../../../utils/pageContent';

const SurveySuccessModal = ({ isDraft, surveyType }) => {
  const navigate = useNavigate();
  const modalData = pulseSurveyPageData.successModalData;
  return (
    <div className="flex justify-center items-center z-50 fixed h-screen w-screen top-0 left-0 bg-black/15 sm:px-10 px-4">
      <div className="h-fit md:w-[692px] sm:w-[500px] w-[calc(100% - 2rem)] rounded-[24px] md:px-24 md:py-16 p-8 bg-shoorah-normanGray dark:bg-shoorah-darkBgColor dark:border-shoorah-darkBorder border-[1.5px] border-shoorah-borderGray">
        <div className="flex justify-center">
          <img src={Like} alt="Like" />
        </div>
        <h1 className="text-2xl font-medium text-center mt-6 text-shoorah-lightBlack dark:text-shoorah-darkBg">
          {surveyType === 'Survey'
            ? isDraft !== 0
              ? modalData.successMessages.sendingSurveyToYourStaff
              : modalData.successMessages.surveyHasBeenDraft
            : modalData.successMessages.creatingTemplate}
        </h1>
        {isDraft !== 0 && (
          <p className="text-base font-normal text-shoorah-lightBlack dark:text-shoorah-darkBg text-center mt-4">
            {modalData.manageSurveyAndAccessInsightsMessage}
          </p>
        )}
        <button
          className="bg-[#1F1F1F] rounded-full px-10 py-3 text-white text-lg block mx-auto mt-8"
          onClick={() => navigate(getPathForSurvey('/pulse-survey'))}
        >
          {surveyType === 'Survey' ? modalData.mySurveyText : modalData.myTemplateText}
        </button>
      </div>
    </div>
  );
};

export default SurveySuccessModal;